import React from 'react'

const DashboardHome = () => {
    return (
        <div>
            Dashboard Home
        </div>
    )
}

export default DashboardHome
